import React from "react";
import { Diamond } from "../../icons/Diamond";
import "./style.css";

export const DiamondWrapper = () => {
  return <Diamond className="diamond-2" color="#6957DA" />;
};
